import { EnhancementDoc } from './enhancementDoc';
import { IcdMapping } from './IcdMapping';
import { PcsMapping } from './PcsMapping';
import { AllEnhancement } from './allEnhancements';

export class EnhancementDto {
    private enhancementNotes: string;
    private claimId: string;
    private patientId: string;
    private patientName: string;
    private authorisedAmount: number;
    private icdMapping: IcdMapping[];
    private pcsMapping: PcsMapping[];
    private allEnhancements: AllEnhancement[];
    private enhancementDocuments: EnhancementDoc[];
    private totalAmount: number;
    private commonNames:String[];
    private dateOfDischarge:Date;
    private admissionDate:Date;

    constructor(enhancementDto: any) {
        this.claimId = enhancementDto.claimId;
        this.patientId = enhancementDto.patientId;
        this.patientName = enhancementDto.patientName;
        this.authorisedAmount = enhancementDto.authorisedAmount;
        this.totalAmount = enhancementDto.totalAmount;
        this.enhancementNotes = enhancementDto.enhancementNotes;
        if (enhancementDto.commonNames) {
            this.commonNames = [];
            for (const pacn of enhancementDto.commonNames) {
                if (pacn) {
                    this.commonNames.push(pacn);
                }
            }
        }
        this.dateOfDischarge=enhancementDto.dateOfDischarge;
        this.admissionDate = enhancementDto.admissionDate;
        if (enhancementDto.icdMapping) {
            this.icdMapping = [];
            for (const doc of enhancementDto.icdMapping) {
                if (doc) {
                    this.icdMapping.push(new IcdMapping(doc));
                }
            }
        }

        if (enhancementDto.pcsMapping) {
            this.pcsMapping = [];
            for (const doc of enhancementDto.pcsMapping) {
                if (doc) {
                    this.pcsMapping.push(new PcsMapping(doc));
                }
            }
        }


        if (enhancementDto.allEnhancements) {
            this.allEnhancements = [];
            for (const doc of enhancementDto.allEnhancements) {
                if (doc) {
                    this.allEnhancements.push(new AllEnhancement(doc));
                }
            }
        }

        if (enhancementDto.enhancementDocuments) {
            this.enhancementDocuments = [];
            for (const doc of enhancementDto.enhancementDocuments) {
                if (doc) {
                    this.enhancementDocuments.push(new EnhancementDoc(doc));
                }
            }
        }
    }

    /**
     * Getter $enhancementNotes
     * @return {string}
     */
    public get $enhancementNotes(): string {
        return this.enhancementNotes;
    }

    /**
     * Setter $enhancementNotes
     * @param {string} value
     */
    public set $enhancementNotes(value: string) {
        this.enhancementNotes = value;
    }

    /**
     * Getter $claimId
     * @return {string}
     */
    public get $claimId(): string {
        return this.claimId;
    }

    /**
     * Getter $patientId
     * @return {string}
     */
    public get $patientId(): string {
        return this.patientId;
    }

    /**
     * Getter $patientName
     * @return {string}
     */
    public get $patientName(): string {
        return this.patientName;
    }

    /**
     * Getter $authorisedAmount
     * @return {number}
     */
    public get $authorisedAmount(): number {
        return this.authorisedAmount;
    }

    /**
     * Getter $icdMapping
     * @return {IcdMapping[]}
     */
    public get $icdMapping(): IcdMapping[] {
        return this.icdMapping;
    }

    /**
     * Getter $pcsMapping
     * @return {PcsMapping[]}
     */
    public get $pcsMapping(): PcsMapping[] {
        return this.pcsMapping;
    }
    /**
     * Getter $commonNames
     * @return {String[]}
     */
    public get $commonNames(): String[] {
        return this.commonNames;
    }
    /**
     * Getter $dateOfDischarge
     * @return {Date}
     */
    public get $dateOfDischarge(): Date {
        return this.dateOfDischarge;
    }
    /**
     * Getter $admissionDate
     * @return {Date}
     */
    public get $admissionDate(): Date {
        return this.admissionDate;
    }
    /**

    /**
     * Getter $allEnhancements
     * @return {AllEnhancement[]}
     */
    public get $allEnhancements(): AllEnhancement[] {
        return this.allEnhancements;
    }

    /**
     * Getter $enhancementDocuments
     * @return {EnhancementDoc[]}
     */
    public get $enhancementDocuments(): EnhancementDoc[] {
        return this.enhancementDocuments;
    }

    /**
     * Getter $totalAmount
     * @return {number}
     */
    public get $totalAmount(): number {
        return this.totalAmount;
    }

    /**
     * Setter $claimId
     * @param {string} value
     */
    public set $claimId(value: string) {
        this.claimId = value;
    }

    /**
     * Setter $patientId
     * @param {string} value
     */
    public set $patientId(value: string) {
        this.patientId = value;
    }

    /**
     * Setter $patientName
     * @param {string} value
     */
    public set $patientName(value: string) {
        this.patientName = value;
    }

    /**
     * Setter $authorisedAmount
     * @param {number} value
     */
    public set $authorisedAmount(value: number) {
        this.authorisedAmount = value;
    }

    /**
     * Setter $icdMapping
     * @param {IcdMapping[]} value
     */
    public set $icdMapping(value: IcdMapping[]) {
        this.icdMapping = value;
    }

    /**
     * Setter $pcsMapping
     * @param {PcsMapping[]} value
     */
    public set $pcsMapping(value: PcsMapping[]) {
        this.pcsMapping = value;
    }
/**
     * Setter $commonNames
     * @param {String[]} value
     */
    public set $commonNames(value: String[]) {
        this.commonNames = value;
    }
     /**
     * Setter $dateOfDischarge
     * @param {Date} value
     */
    public set $dateOfDischarge(value: Date) {
        this.dateOfDischarge = value;
    }
    /**
     * Setter $admissionDate
     * @param {Date} value
     */
    public set $admissionDate(value: Date) {
        this.admissionDate = value;
    }
    /**
     * Setter $allEnhancements
     * @param {AllEnhancement[]} value
     */
    public set $allEnhancements(value: AllEnhancement[]) {
        this.allEnhancements = value;
    }

    /**
     * Setter $enhancementDocuments
     * @param {EnhancementDoc[]} value
     */
    public set $enhancementDocuments(value: EnhancementDoc[]) {
        this.enhancementDocuments = value;
    }

    /**
     * Setter $totalAmount
     * @param {number} value
     */
    public set $totalAmount(value: number) {
        this.totalAmount = value;
    }

}
